<img src="/assets/logo/large-logo.svg" alt="background-img" class="background-img" />
<div class="Chess-Puzzles-page-background-color">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-8 puzzle-section text-center">
        <div class="mt-3 text-center">
          <div class="d-flex justify-content-center">
            <div class="Main-chessBoard">
              <div #boardContainer id="hijk"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-4 py-3 puzzle-menu-section">
        <div>
          <div>
            <div>
            <div class="w-20 " style="color: var(--default-font-color); cursor: pointer;width: fit-content;" (click)="puzzleMainroute()">
              @if(puzzleMenu == false){
              <i class="fa-solid me-1 fa-arrow-left" style="color: var(--default-font-color);"
                ></i>back
              }
            </div>
            <div class="w-80 d-flex align-items-center justify-content-center">
              <div class="">
                <h2 class="text-center Chess-Puzzles-title-text">
                  Chess Puzzles
                </h2>
              </div>
            </div>
          </div>

            <div class="text-center play-main-box my-3">
              <img src="../../../../assets/puzzles/Puzzle-img.png" style="width: 20%" alt="" />
            </div>
          </div>

          @if(puzzleMenu == true){
          <div class="d-grid puzzle-main-manu">
            <div class="d-flex justify-content-center" (click)="puzzleStartGame()">
              <div class="d-flex align-items-center puzzle-menu p-2 px-4">
                <div class="img-box-size">
                  <img src="../../../../assets/puzzles/puzzle-mode.svg" class="img-size" alt="back" />
                </div>
                <div class="ms-3">
                  <h5 class="text-start Puzzles-box-text">Puzzles</h5>
                  <p class="m-0 text-start box-paragraph-text">
                    Train with more than 100,000 puzzles
                  </p>
                </div>
              </div>
            </div>


            <div class="d-flex justify-content-center" (click)="puzzlemode()">
              <div class="d-flex align-items-center puzzle-menu p-2 px-4">
                <div class="img-box-size">
                  <img src="../../../../assets/puzzles/custom-puzzle.svg" class="img-size" alt="" />
                </div>
                <div class="ms-3">
                  <h5 class="text-start Puzzles-box-text">Custom Puzzles</h5>
                  <p class="m-0 text-start box-paragraph-text">
                    Choose puzzles by themes and rating
                  </p>
                </div>
              </div>
            </div>

            <div class="d-flex justify-content-center" (click)="dailyPuzzle()">
              <div class="d-flex align-items-center puzzle-menu p-3">
                <div class="img-box-size">
                  <img src="../../../../assets/puzzles/daily-puzzle.svg" class="img-size" alt="" />
                </div>
                <div class="ms-3">
                  <h5 class="text-start Puzzles-box-text">Daily Puzzle</h5>
                  <p class="m-0 text-start box-paragraph-text">
                    Can you solve today’s puzzle?
                  </p>
                </div>
              </div>
            </div>
            <!-- } -->
          </div>

          <div class="d-flex justify-content-center">
            <div class="d-flex justify-content-center align-items-center puzzle-stats mt-4 p-2"
              routerLink="complatedpuzzle">
              <h5 class="text-center m-0 Puzzles-box-text">Solved Puzzles</h5>
            </div>
          </div>
          }@else{
          <div class="mb-2">
            @if(puzzlesolvedText){
            <h3 class="puzzle-solved-Text">{{puzzlesolvedText}}</h3>
            }
          </div>

          <div class="">
         @if(puzzleRatingShow){
            <div class="d-flex justify-content-center mb-2">
              @if(puzzleRatingData){
              <p class="m-0 ms-2 rating-text px-2 py-1">
                {{ puzzleRatingData }}
                @if(!isNaN(currentpuzzlerating) && currentpuzzlerating !== null){
                <span [ngClass]="{
                    'red-text': currentpuzzlerating < 0,
                    'green-text': currentpuzzlerating >= 0}">
                  {{
                  currentpuzzlerating >= 0
                  ? "+" + currentpuzzlerating
                  : currentpuzzlerating
                  }}
                </span>
                }
              </p>
              }
            </div>
            } 
            @if(!PuzzleBoard){
            @for (item of selectedOptions; track $index) {
            <div style="border-bottom: 2px solid #535250" class="d-flex align-items-center my-2">
              <p class="Puzzles-box-text m-0">{{ item }}</p>
              <i class="fa-solid fa-xmark mx-3" style="color: red; cursor: pointer"
                (click)="removeSelectoption($index)"></i>
            </div>
            }
            }@else {
            <div class="puzzle-themes justify-content-center row mb-2">
              @for (theme of themes; track $index) {
              <div class="themes text-center col-lg-4 col-10">
                {{ theme }}
              </div>
              }
            </div>
            }
          </div>


      
            @if(!nextpuzzlebtn && custompuzzle){
              <div>
                <form [formGroup]="puzzleOption" (ngSubmit)="puzzleData()">
                  <div class="theme-mobile-section">
                    <div class="d-flex justify-content-center">
                      <select class="form-select w-75" formControlName="TacticalThemes"
                        (change)="onCustomerChanged($event)">
                        <option selected="true" disabled="disabled">
                          Tactical Themes
                        </option>
                        <option value="sacrifice">Sacrifice</option>
                        <option value="clearance">Clearance</option>
                        <option value="skewer">Skewer</option>
                        <option value="doubleBishopMate">Double Bishop Mate</option>
                        <option value="interference">Interference</option>
                        <option value="oneMove">One Move</option>
                        <option value="zugzwang">Zugzwang</option>
                        <option value="xRayAttack">X-Ray Attack</option>
                        <option value="deflection">Deflection</option>
                        <option value="pin">Pin</option>
                        <option value="discoveredAttack">Discovered Attack</option>
                        <option value="fork">Fork</option>
                        <option value="doubleCheck">Double Check</option>
                        <option value="intermezzo">
                          Intermezzo (also known as Zwischenzug)
                        </option>
                      </select>
                    </div>
    
                    <div class="d-flex justify-content-center">
                      <select class="form-select w-75" formControlName="Mate" (change)="onCustomerChanged($event)">
                        <option selected="true" disabled="disabled">Mate</option>
                        <!-- <option value="mate">mates (249145)</option> -->
                        <option value="mateIn1">mate in 1</option>
                        <option value="mateIn2">mate in 2</option>
                        <option value="mateIn3">mate in 3</option>
                        <option value="mateIn4">mate in 4</option>
                        <option value="mateIn5">mate in 5</option>
                      </select>
                    </div>
    
                    <div class="d-flex justify-content-center">
                      <select class="form-select w-75" formControlName="EndgameTactics"
                        (change)="onCustomerChanged($event)">
                        <option selected="true" disabled="disabled">
                          Endgame Tactics
                        </option>
                        <option value="bishopEndgame">Bishop Endgame</option>
                        <option value="rookEndgame">Rook Endgame</option>
                        <option value="queenEndgame">Queen Endgame</option>
                        <option value="knightEndgame">Knight Endgame</option>
                        <option value="pawnEndgame">Pawn Endgame</option>
                        <option value="queenRookEndgame">Queen Rook Endgame</option>
                      </select>
                    </div>
    
                    <div class="d-flex justify-content-center">
                      <select class="form-select w-75" formControlName="OpeningTactics"
                        (change)="onCustomerChanged($event)">
                        <option selected="true" disabled="disabled">
                          Opening Tactics
                        </option>
                        <option value="opening">Opening</option>
                        <option value="kingsideAttack">Kingside Attack</option>
                        <option value="queensideAttack">Queenside Attack</option>
                        <option value="attackingF2F7">Attacking f2/f7</option>
                        <option value="castling">Castling</option>
                      </select>
                    </div>
    
                    <div class="d-flex justify-content-center">
                      <select class="form-select w-75" formControlName="MatingPatterns"
                        (change)="onCustomerChanged($event)">
                        <option selected="true" disabled="disabled">
                          Mating Patterns
                        </option>
                        <option value="hookMate">Hook Mate</option>
                        <option value="arabianMate">Arabian Mate</option>
                        <option value="smotheredMate">Smothered Mate</option>
                        <option value="anastasiaMate">Anastasia Mate</option>
                        <option value="bodenMate">Boden Mate</option>
                        <option value="dovetailMate">Dovetail Mate</option>
                        <option value="backRankMate">Back Rank Mate</option>
                      </select>
                    </div>
    
                    <div class="d-flex justify-content-center">
                      <select class="form-select w-75" formControlName="StrategicThemes"
                        (change)="onCustomerChanged($event)">
                        <option selected="true" disabled="disabled">
                          Strategic Themes
                        </option>
                        <option value="exposedKing">Exposed King</option>
                        <option value="advancedPawn">Advanced Pawn</option>
                        <option value="defensiveMove">Defensive Move</option>
                        <option value="advantage">Advantage</option>
                        <option value="equality">Equality</option>
                        <option value="middlegame">Middlegame</option>
                        <option value="endgame">Endgame</option>
                        <option value="superGM">Super GM</option>
                        <option value="master">Master</option>
                        <option value="masterVsMaster">Master vs Master</option>
                      </select>
                    </div>
    
                    <div class="d-flex justify-content-center">
                      <select class="form-select w-75" formControlName="SpecialMoves" (change)="onCustomerChanged($event)">
                        <option selected="true" disabled="disabled">
                          Special Moves
                        </option>
                        <option value="underPromotion">Underpromotion</option>
                        <option value="enPassant">En Passant</option>
                        <option value="promotion">Promotion</option>
                        <option value="quietMove">Quiet Move</option>
                        <option value="capturingDefender">
                          Capturing Defender
                        </option>
                        <option value="hangingPiece">Hanging Piece</option>
                        <option value="trappedPiece">Trapped Piece</option>
                      </select>
                    </div>
                  </div>
                  <div class="d-flex justify-content-center my-2">
                    <div style="cursor: pointer;width: fit-content;color: var(--default-font-color);"
                      (click)="toggleAdvancedOptions()">
                      Custom
                      <i class="fas" [ngClass]="showAdvancedOptions ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
                    </div>
                  </div>
    
                  @if(showAdvancedOptions){
                  <div class="advanced-options">
                    <div class="row mb-3 justify-content-center">
                      <div class="form-group col-9">
                        <label for="minRating" class="box-paragraph-text">Minimum Rating</label>
                        <input type="number" id="minRating" formControlName="minRating" class="form-control"
                          placeholder="e.g. 200" />
                      </div>
                      <div class="form-group col-9">
                        <label for="maxRating" class="box-paragraph-text">Maximum Rating</label>
                        <input type="number" id="maxRating" formControlName="maxRating" class="form-control"
                          placeholder="e.g. 1275" />
                        <div *ngIf="puzzleOption.hasError('ratingRangeInvalid') && puzzleOption.get('maxRating')?.touched"
                          class="invalid-feedback">
                          Maximum Rating must be greater than or equal to Minimum Rating.
                        </div>
                      </div>
                    </div>
    
                    @if(errorMessage){
                    <div class="alert alert-danger mt-2">
                      {{ errorMessage }}
                    </div>
                    }
                  </div>
                  }
                  <div class="text-center">
                    @if(selectedpuzzle){
                    <p class="selectedpuzzle mb-2">{{selectedpuzzle}}</p>
                    }
                    <button class="btn w-25 puzzle-start-btn" [disabled]="puzzleOption.invalid || loading" type="submit">
                      <b *ngIf="!loading">Start</b>
                      <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status"
                        aria-hidden="true"></span>
                    </button>
    
                  </div>
                </form>
              </div>
            }

           @if(nextpuzzlebtn){
            <div>
              <h5 id="puzzlemove" class="Available-puzzle">Finish this puzzle in <span class="">{{puzzleMove?.length /
                  2}}</span> Move.</h5>
  
              <div class="d-flex">
                @if(!puzzleRatingShow){
                <button (click)="PuzzleHit()" id="puzzleHit" class="btn w-100 mt-2 mx-1 mb-2 p-3">
                  <b>Hint</b></button>}
                @if(nextPuzzleBtn){
                <button class="btn next-puzzle-btn mx-1 w-100 mt-2 mb-2 p-3"
                  (click)="ratedNextpuzzle ? nextratedPuzzle() : nextPuzzle()">
                  <b>Next Puzzle</b>
                </button>
                }@else if(allpuzzlefinish){
                <p class="text-white" id="finishAllPuzzle">
                  Congratulations puzzle is Finished.
                </p>
                }
              </div>
            </div>
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>


<app-login-popup
  [displayStyle]="modalDisplayStyle"
  (myout)="GetChildData($event)"
></app-login-popup>
